module.exports = __webpack_public_path__ + "static/rem-17b4fdd30acf13edc17d6b8f8d136c92.png";